var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServices05(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 503.13 461.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": 2045594509296
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.63,114.07a7,7,0,0,1,9.9,0Q440,215.52,541.43,317l26.82-26.82-79.5-79.5a7,7,0,0,1-2.05-5V109H433.84v29.81a7,7,0,0,1-12,4.91L333.58,55.48,98.92,290.15,125.74,317ZM375.1,486.35V377.69a41.51,41.51,0,0,0-83,0V486.35Zm-97,0V377.69a55.51,55.51,0,0,1,111,0V486.35h127V311.41L333.58,128.92,155.11,307.39v179Zm252-160.94V493.35a7,7,0,0,1-7,7h-375a7,7,0,0,1-7-7v-172l-10.42,10.43a7,7,0,0,1-9.9,0L84.07,295.1a7,7,0,0,1,0-9.9L328.63,40.63a7,7,0,0,1,9.9,0l81.31,81.31V102a7,7,0,0,1,7-7H493.7a7,7,0,0,1,7,7V202.8l82.4,82.4a7,7,0,0,1,0,9.9l-36.72,36.72a7,7,0,0,1-9.9,0l-6.41-6.41Z",
    transform: "translate(-82.02 -38.58)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices05);
export default __webpack_public_path__ + "static/media/services_05.f2ed1c208bf4723b27db2dd934c20907.svg";
export { ForwardRef as ReactComponent };